module.exports = __webpack_public_path__ + "static/img/oocl.e1412ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/oocl.png
// module id = czrZ
// module chunks = 9